export const LEGEND_COLORS = [
  "var(--primary-40)",
  "var(--success-20)",
  "var(--accent-secondary-20)",
  "var(--accent-tertiary-40)",
  "var(--danger-20)",
  "var(--caution-20)",
  "var(--accent-primary-60)",
  "var(--success-60)",
  "var(--accent-secondary-40)",
  "var(--accent-tertiary-20)",
  "var(--primary-80)",
  "var(--accent-primary-80)",
  "var(--accent-tertiary-80)",
  "var(--danger-80)",
];

export type NotarizeCountScalarHash = {
  label: string;
  count: number | null;
} & NotarizeScalarHash;

export function isNotarizeCountScalarHashArray(
  arr: NotarizeScalarHash[],
): arr is NotarizeCountScalarHash[] {
  return arr.every((item) => typeof item.count === "number");
}
